var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var MainMenu = function () {
	this.$menuContainer = $( '.main-menu' );
	this.$header = $( '.header' );
	this.$mainMenuLinks = $( '.main-menu__inner ul li a' );
};

MainMenu.prototype.init = function () {
	var self = this;
	var $window = $( window );

	self.$mainMenuLinks.each( function() {
        $(this).on('focusin', function() {
            $(this).parent().parent().parent(".main-menu__inner").addClass('child-link-focused');
        });
        $(this).on('focusout', function() {
            $(this).parent().parent().parent(".main-menu__inner").removeClass('child-link-focused');
        });
    });

	function setMenuCSS() {
		var $headerHeight = $( '.header__inner' ).outerHeight();
		self.$header.css( { 'height': $headerHeight } );
		if( $( '#wpadminbar' ).length ) {
		    $headerHeight = $headerHeight + 32;
        }
        self.$menuContainer.css( { 'top': $headerHeight, 'height': 'calc(100% - ' + $headerHeight + 'px)' } );
    }

	setMenuCSS();

	$window.resize(
		function () {
            setMenuCSS();
		}
	);
};

module.exports = new MainMenu();
